import axios from 'axios';
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useHistory } from 'react-router';
import { getSession, valdiatePage } from '../../global';
import { getLocations, getMultipleSubAccountLocations } from '../../services/userservice';
import { bookingSummaryReport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import MemoDestinationsDDL from '../../components/memoDestinationsDDL';
// import ExportExcel from '../../components/exportexcel';
import ExportExcelButton from "../../components/exportExcelButton";
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';
import { getSubAccountLocations } from "../../services/userservice";
import { MultiSelect } from 'react-multi-select-component';
import '../booking/booking.css';

 export const bookingSummaryColumns = [
  { label: "CN", key: "cn" },
  { label: "Consigner Account No", key: "consignerAccountNo" },
  { label: "Location Name", key: "locationName" },
  { label: "Booking Date", key: "bookingDate" },
  { label: "Ref No", key: "refNo" },
  { label: "Consignee", key: "consignee" },
  { label: "Consignee Address", key: "consigneeAddress" },
  { label: "Consignee Phone No", key: "consigneePhoneNo" },
  { label: "Consignee Email", key: "consigneeEmail" },
  { label: "COD Amount", key: "codAmount" },
  { label: "Product Description", key: "productDescription" },
  { label: "Weight", key: "weight" },
  { label: "Origin", key: "origin" },
  { label: "Destination", key: "destination" },
  { label: "Remarks", key: "remarks" },
];

const BookingSummary = () => {
    const { destinations } = useSelector(state => state.appData);
    const { accounts, subaccounts } = useSelector(state => state.appData);
    const dispatch = useDispatch();

    const userInfo = getSession('userInfo');
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const destinationsOption = destinations.map(i => ({label: i.text, value: i.value}));

    const history = useHistory();
    const d = {
        from: today,
        to: today,
        locationId: [],
        destinationCity: [],
        consignee: '',
        consigneePhone: '',
        refNo: '',
        status: '1',
        account: accounts.join(),
        subAccountId:  []
    };
    const [data, setData] = useState(d);
    const [locations, setLocations] = useState([]);
    const [grid, setGrid] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedDest, setSelectedDest] = useState([]);


     
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        cn: '',
        bookingDate: '',
        refNo: '',
        consignee: '',
        consigneePhoneNo: '',
        codAmount: '',
        weight: '',
        origin: '',
        destination: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'cn', name: 'CN', searchBox: true, visible: true},
        {key: 'consignerAccountNo', name: 'Account#', searchBox: false, visible: true},
        {key: 'locationName', name: 'Location Name', searchBox: false, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'arrivalDate', name: 'Arrival Date', searchBox: false, visible: data.status == '3'},
        {key: 'refNo', name: 'Ref No', searchBox: true, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},
        {key: 'consigneeAddress', name: 'Consignee Address', searchBox: false, visible: true},
        {key: 'consigneePhoneNo', name: 'Consignee Phone No', searchBox: true, visible: true},
        {key: 'consigneeEmail', name: 'Consignee Email', searchBox: false, visible: true},
        {key: 'codAmount', name: 'Cod Amount', searchBox: true, visible: true},
        {key: 'productDescription', name: 'Product Description', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: true, visible: true},
        {key: 'origin', name: 'Origin', searchBox: true, visible: true},
        {key: 'destination', name: 'Destination', searchBox: true, visible: true},
        {key: 'remarks', name: 'Remarks', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });




    const destRef = useRef(null);
    useEffect(() => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (!valdiatePage('/bookingsummary')) {
            history.push('/login');
        }
        // if (valdiatePage('/bookingsummary')) {
        //     const loadData = async (source) => {
        //         const locs = await getLocations(userInfo.id, '', source);
        //         if (locs && locs.length > 0) {
        //             setLocations(locs);
        //             setData({ ...data, locationId: [locs[0].value.toString()] })
        //         }
        //     };
        //     loadData(source);
        // } else {
        //     history.push('/login');
        // }
        return () => {

        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {
        setGrid([]);
        if (!data.from) {
            alert('Enter From date');
            return;
        }
        if (!data.to) {
            alert('Enter To date');
            return;
        }

        if (Date.parse(data.from) > Date.parse(data.to)) {
            alert('Invalid Date Range');
            return;
        }

        setLoading(true);
        var rs = await bookingSummaryReport(data);
        setLoading(false);
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            } else {
                alert('No Data Found');
            }
        }
        else {
            alert(rs.msg);
        }
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Bookings</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row pb-2">
                <div className="col">
                    <label>From</label>
                    <input type="date" className="form-control" value={data.from} onChange={(e) => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>To</label>
                    <input type="date" className="form-control" value={data.to} onChange={(e) => updateData('to', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                    const selectedOptions = Array.from(e.target.selectedOptions);

                        const accnos = selectedOptions
                            .map(option => option.getAttribute('data-accno'))
                            .filter(acc => acc && acc.trim() !== '');
                
                        const uniqueAccnos = Array.from(
                            new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                        );

                        const val = Array.from(new Set(
                            selectedOptions
                                .map(option => option.value)
                                .filter(v => v && !isNaN(v))
                                .map(v => parseInt(v))
                        ));

                        const d = { ...data, subAccountId: val, account: uniqueAccnos.join() };
                        if (val) {
                            //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                            if (locs && locs.length > 0) {
                                d.locationId = [String(+locs[0].value)]
                                setLocations(locs);
                            }
                        } else {
                            setLocations([]);
                            //d.isCod = null;
                        }
                        setData({ ...d});
                    }}>
                        <option value="" data-accno="" data-iscod="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Location</label>
                    <select className="form-select" multiple value={data.locationId} onChange={(e) => {
                        let value = Array.from(e.target.selectedOptions, option => option.value);
                        console.log(value);
                        updateData('locationId', value)
                    }} >
                        {
                            locations.length > 0 && locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row pb-2">

                <div className="col-lg-3">
                    <label>Destination</label>
                    <MultiSelect
                        options={destinationsOption}
                        value={selectedDest}
                        onChange={(e) => {
                        const val = e.map(s => s.value);
                         updateData('destinationCity', val)
                         setSelectedDest(e)
                        }}
                        className="multi-destination"
                    />
                </div>
                
                <div className="col-lg">
                    <label>Consignee Name</label>
                    <input type="text" className="form-control booking-summary-control" value={data.consignee} onChange={(e) => updateData('consignee', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Consignee Phone</label>
                    <input type="text" className="form-control booking-summary-control" value={data.consigneePhone} onChange={(e) => updateData('consigneePhone', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Reference Number</label>
                    <input type="text" className="form-control booking-summary-control" value={data.refNo} onChange={(e) => updateData('refNo', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Status</label>
                    <select className="form-select booking-summary-control" value={data.status} onChange={(e) => updateData('status', e.target.value)}>
                        <option value="1">Booked</option>
                        <option value="2">Loadsheet</option>
                        <option value="3">Arrival at M&P Booking</option>
                        <option value="4">Cancelled</option>
                    </select>
                </div>
                <div className="col-lg">
                    <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem' }} onClick={onSearch}>
                        {loading ? <img src={Loader} height="30" /> : 'Search'}
                    </button>
                </div>
            </div>

            {
                originalGrid && originalGrid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div className='row'>
                            <div className="col-lg col-lg-12" style={{ textAlign: 'right' }}>
                                {/* <ExportExcel data={originalGrid} /> */}
                               { console.log("bookinf BookingSummary",originalGrid)}
                                <ExportExcelButton data={originalGrid} columns={bookingSummaryColumns} fileName="Booking_Summary_Report"
                                />
                            </div>
                        </div>
                        
                        <br />
                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <tr key={index}>
                                        <td>{(index + 1)+(page*pageLimit)}</td>
                                        <td>
                                            <span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={(e) => {
                                                e.preventDefault();
                                                sessionStorage.setItem('cn', x.cn);
                                                window.open('/cplight/tracking_2', '_blank');
                                            }}>{x.cn}</span>
                                        </td>
                                        <td>{x.consignerAccountNo}</td>
                                        <td style={{ minWidth: 300 }}>
                                            <SeeMoreModal detail={x.locationName} maxLength={120} />
                                        </td>
                                        <td>{x.bookingDate}</td>
                                        {data.status == 3 && <td>{x.arrivalDate}</td>}
                                        <td>{x.refNo}</td>
                                        <td>{x.consignee}</td>
                                        <td style={{ minWidth: 300 }}>
                                            <SeeMoreModal detail={x.consigneeAddress} maxLength={120} />
                                        </td>
                                        <td>{x.consigneePhoneNo}</td>
                                        <td>{x.consigneeEmail}</td>
                                        <td>{x.codAmount}</td>
                                        <td style={{ minWidth: 300 }}>
                                            <SeeMoreModal detail={x.productDescription} maxLength={120} />
                                        </td>
                                        <td>{x.weight}</td>
                                        <td>{x.origin}</td>
                                        <td>{x.destination}</td>
                                        <td style={{ minWidth: 300 }}>
                                            <SeeMoreModal detail={x.remarks} maxLength={120} />
                                        </td>
                                    </tr>)
                            }
                        />
                    </div>
                </div>
            }
        </div>
    </section>
}

export default BookingSummary
